import { render } from "./CourseAndSubject.vue?vue&type=template&id=7fbccb3c"
import script from "./CourseAndSubject.vue?vue&type=script&lang=js"
export * from "./CourseAndSubject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__